/**
 * The editor's paragraph look on this device (part 10a, table S; part 11's table G, G10): the choice, and the look it
 * gives with a book's theme.
 */
import type { ParagraphLook } from '@cockatrice/editor';
import type { Theme } from '@cockatrice/layout';

/**
 * How the editor sets paragraphs apart (G10, part 10a): the book look (first-line indents as the preview, no gap) or the
 * block look (half a line between blocks, no indent).
 */
export const PARAGRAPH_LOOKS = ['book', 'block'] as const;
export type ParagraphLookChoice = (typeof PARAGRAPH_LOOKS)[number];

/** G10: the editor's look for `choice`, the book look from `theme` (its indent, paragraph spacing and break rule). */
export function paragraphLookOf(choice: ParagraphLookChoice, theme: Theme): ParagraphLook {
  if (choice === 'block') return { kind: 'block' };
  return { kind: 'book', indent: theme.firstLineIndent / 10, gap: theme.paragraphSpacing / 10, indentAfterBreak: theme.indentAfterBreak };
}
